// extracted by mini-css-extract-plugin
export default {"link":"styles_link__KypAQ","list":"styles_list__MYpft","button":"styles_button__iSQHG"};